<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <!-- <div>
      <app-inclusions-and-exclusions (makeFormDirty)="markFormDirty($event)" [hideFooter]="true" [leadId]="leadId" [itineraryId]="itineraryId" (storeFormData)="storeInclusionsAndExclusionData($event)" [storedFormData]="inclusionsAndExclusionsFormData" [editInventory]="editInventory? true: false" [editQuote]="editQuote? true : false"></app-inclusions-and-exclusions>
    </div> -->
    <div>
      <app-terms-and-conditions (makeFormDirty)="markFormDirty($event)" [hideFooter]="true" [leadId]="leadId" [itineraryId]="itineraryId" (storeFormData)="storeTermsAndConditionsData($event)" [storedFormData]="termsAndConditionsFormData" [editInventory]="editInventory? true: false" [editQuote]="editQuote? true : false"></app-terms-and-conditions>
    </div>
    <div *ngIf="leadId">
      <app-payment-terms-and-conditions (makeFormDirty)="markFormDirty($event)" [hideFooter]="true" [leadId]="leadId" [itineraryId]="itineraryId" (storeFormData)="storePaymentTermsAndConditionsData($event)" [storedFormData]="paymentTermsAndConditionsFormData" [editInventory]="editInventory? true: false" [editQuote]="editQuote? true : false"></app-payment-terms-and-conditions>
    </div>
    <div>
      <app-cancellation-policy (makeFormDirty)="markFormDirty($event)" [hideFooter]="true" [leadId]="leadId" [itineraryId]="itineraryId" (storeFormData)="storeCancellationPolicyData($event)" [storedFormData]="cancellationPolicyFormData" [editInventory]="editInventory? true: false" [editQuote]="editQuote? true : false"></app-cancellation-policy>
    </div>
  </div>

  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified() && termsAndConditionsFormData">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified() && termsAndConditionsFormData">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
  
</div>